export default function () {
    var user = localStorage.getItem("currentUser") || sessionStorage.getItem("currentUser")
    if (!(user === null)) {
        const currentUser = JSON.parse(user);
        if (currentUser && currentUser.token) {
            return `Bearer ${currentUser.token}`;
        }
    }

    return {};
}